import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {
    retrieveFieldSites({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("fieldSite/retrieveFieldSites").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveFieldSitesBySearch({ commit }, filter) {
        commit("SET_LOADING", true);
        return getAPI("fieldSite/retrieveFieldSitesBySearch" , filter)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveFieldSiteById({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("fieldSite/retrieveFieldSiteById" , {id:id})
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      saveFieldSite({ commit }, fieldSite) {
        commit("SET_LOADING", true);
        return postAPI("fieldSite/saveFieldSite", fieldSite).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      deleteFieldSite({ commit } , id) {
        commit("SET_LOADING", true);
        return postAPI("fieldSite/deleteFieldSite/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveFieldSitesByUserId({ commit }, userId) {
        commit("SET_LOADING", true);
        return getAPI("fieldSite/retrieveFieldSitesByUserId" , userId)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      countFieldSites({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("fieldSite/count").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },
};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };